import { render } from "./PelviPerineologyChildren.vue?vue&type=template&id=1e51be7b&scoped=true"
import script from "./PelviPerineologyChildren.vue?vue&type=script&lang=js"
export * from "./PelviPerineologyChildren.vue?vue&type=script&lang=js"

import "./PelviPerineologyChildren.vue?vue&type=style&index=0&id=1e51be7b&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e51be7b"]])

export default __exports__